// extracted by mini-css-extract-plugin
export var attribution = "_b2-4";
export var authorName = "_b2-5";
export var quote = "_b2-3";
export var testimonial = "_b2-2";
export var trustedBy = "_b2-0";
export var trustedByLabel = "_b2-1";